import startCase from 'lodash/startCase'

export const IMPORT_TYPE = 'user_disable'

/** Registry for bulk user data / import-log types (API `value` matches backend).
 *  Each option may set `exampleCsv`: `{ content, download }` for an inline sample, or
 *  `{ href, download }` when `href` is a full URL (skip `content`). Omit `exampleCsv` to hide the link. */
export const USER_IMPORT_MANAGEMENT_OPTIONS = [
    {
        value: 'user_disable',
        selectLabel: 'Bulk Delete Users',
        listTitle: 'Bulk Delete Users',
        historyTitle: 'Bulk Delete User History',
        noResultsMessage:
            'No bulk delete imports yet. Upload a CSV with an email column for each user to remove.',
        uploadSuccessMessage: 'Bulk delete import queued successfully.',
        instructions:
            'Upload a CSV with a single column with the header "email". Include a row containing the email address of each user you intend to delete. Use Download CSV to retrieve the uploaded file for each import.',
        exampleCsv: {
            content: 'email\nuser@example.com\n',
            download: 'example-bulk-delete-users.csv',
        },
    },
]

/** Build a `data:` URL for an inline example CSV (used by Manage Data “example here” link). */
export function exampleCsvDataHref(csvText) {
    return 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvText)
}

export const getUserImportManagementOption = (value) =>
    USER_IMPORT_MANAGEMENT_OPTIONS.find((o) => o.value === value) ??
    USER_IMPORT_MANAGEMENT_OPTIONS[0]
export const DEFAULT_ERROR_MESSAGE = 'Whoops, there was a problem...'
export const POLL_INTERVAL_MS = 30 * 1000
export const TWENTY_FOUR_H_MS = 24 * 60 * 60 * 1000

export const importLogId = (row) => row?.originId ?? row?.id

export const formatImportTypeLabel = (value) => {
    if (value === 'user_disable') return 'Bulk Delete Users'
    return startCase((value || '').replaceAll('_', ' '))
}

export const isCreatedWithinLast24Hours = (createdAt) => {
    if (!createdAt) return false
    const t = new Date(createdAt).getTime()
    if (Number.isNaN(t)) return false
    return t >= Date.now() - TWENTY_FOUR_H_MS
}

export function axiosHydraMessage(err) {
    const d = err?.response?.data
    if (!d) return null
    if (Object.prototype.hasOwnProperty.call(d, 'hydra:description')) {
        return d['hydra:description']
    }
    if (Array.isArray(d.violations) && d.violations.length > 0) {
        return d.violations
            .map((v) => v.message)
            .filter(Boolean)
            .join(' ')
    }
    return null
}
